import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { LoaderHandler } from 'planning-portal-library/src/lib/core/domain/models/loader-enabler';
import { PlanScheduled } from 'planning-portal-library/src/lib/core/domain/models/scheduler/plan-scheduled';
import { SetCurrentPage, SetFilters, SetPlansScheduled } from './scheduler.action';
import { FiltersScheduler } from 'planning-portal-library/src/lib/core/domain/models/scheduler/filters-scheduler';

export class SchedulerStateModel {
  plansScheduled: PlanScheduled[] | undefined;
  currentPage: number | undefined;
  loading: LoaderHandler[] | undefined;
  filters: FiltersScheduler | undefined;
}

const defaults = {
  plansScheduled: undefined,
  currentPage: undefined,
  loading: undefined,
  filters: undefined
};

@State<SchedulerStateModel>({
  name: 'Scheduler',
  defaults,
})

@Injectable()
export class SchedulerState {

  @Selector()
  static GetPlansScheduled(state: SchedulerStateModel) {
    return state.plansScheduled;
  }

  @Selector()
  static GetCurrentPage(state: SchedulerStateModel) {
    return state.currentPage;
  }

  @Selector()
  static GetFilters(state: SchedulerStateModel) {
    return state.filters;
  }

  @Action(SetPlansScheduled)
  SetPlansScheduled( ctx: StateContext<SchedulerStateModel>, { payload }: SetPlansScheduled) {
    ctx.setState({ ...ctx.getState(), plansScheduled: payload });
  }

  @Action(SetFilters)
  SetPlanFilters( ctx: StateContext<SchedulerStateModel>, { payload }: SetFilters) {
    ctx.setState({ ...ctx.getState(), filters: payload });
  }

  @Action(SetCurrentPage)
  SetCurrentPage( ctx: StateContext<SchedulerStateModel>, {payload} : SetCurrentPage) {
    ctx.setState({ ...ctx.getState(), currentPage: payload });
  }
}
